<template>
  <slot :var="value" />
</template>

<script setup lang="ts" generic="T">
defineProps<{value: T}>();
</script>
